/**
 * Lightbox — GLightbox Initialisierung
 * Wird global initialisiert wenn [data-glightbox] Elemente auf der Seite existieren
 */
export function initLightbox() {
    if (typeof GLightbox === 'undefined') return;
    if (!document.querySelector('[data-glightbox]')) return;

    GLightbox({
        selector: '[data-glightbox]',
        touchNavigation: true,
        loop: true,
        autoplayVideos: false,
        openEffect: 'zoom',
        closeEffect: 'zoom',
        slideEffect: 'slide',
        moreText: 'Mehr anzeigen',
        moreLength: 60,
        closeOnOutsideClick: true,
    });
}
